import './styles/supportChatWidget.scss';

import Cookies from 'js-cookie';
import {isMobile} from "../../utils/utils";
import {Component} from "react";

class SupportChatWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            messengerActive: false,
            popupActive: false,
            isMobile: false,
            bitrixOnlineChat: false
        };
    }

    componentDidMount() {
        if(isMobile()) {
            this.setState({
                isMobile: true,
            });
        }

        let timerId = setTimeout(() => {
            this.setState({
                popupActive: Cookies.get('chat-hello-popup') !== "true"
            }, () => clearTimeout(timerId));
        }, 1000);

        process.env.REACT_APP_NODE_ENV === "production" && this.setBitrixScript();
    }

    setBitrixScript(){
        if (!document.getElementById('bitrix-chat-script')) {
            const script = document.createElement('script');

            script.id = 'bitrix-chat-script';
            script.src = 'https://cdn-ru.bitrix24.ru/b148719/crm/site_button/loader_4_gnq73n.js?' + (Date.now()/60000|0);
            script.async = true;
            script.onload = () => {
                this.setState({
                    bitrixOnlineChat: true
                });
            };
            document.body.appendChild(script);
        }
    }

    toggleLines(showLines) {
        this.setState({
            messengerActive: showLines,
        })
    }

    hidePopup() {
        if(this.state.popupActive) {
            this.setState({
                popupActive: false
            }, () => Cookies.set('chat-hello-popup', "true"));
        }
    }

    openBitrixChat() {
        if (window.BXLiveChat) {
            window.BXLiveChat.open();
        } else {
            console.error('Чат заботы не загружен');
        }
    }

    closeBitrixChat() {
        window.BXLiveChat && window.BXLiveChat.close();
    }

    render() {
        return (
            <div id="support-chat-widget" className={`support-chat-widget ${this.state.isMobile && 'bx-touch'}`}>
                <div className={`chat-widget-button-shadow ${this.state.messengerActive ? 'chat-widget-button-show' : 'chat-widget-button-hide'}`}
                onClick={this.toggleLines.bind(this, false)}></div>
                <div dir="ltr" className={`chat-widget-button-wrapper chat-widget-button-position-bottom-right chat-widget-button-visible
                 ${this.state.messengerActive && 'chat-widget-button-bottom'}`}>
                    <div className={`chat-widget-button-popup ${this.state.popupActive && 'chat-widget-button-popup-show'}`}
                         onClick={(e) => {e.stopPropagation(); this.hidePopup()}}>
                        <span className="chat-widget-button-popup-btn-hide"></span>
                        <div className="chat-widget-button-popup-inner">
                            <div className="chat-widget-button-popup-image">
                                <span className="chat-widget-button-popup-image-item"></span>
                            </div>
                            <div className="chat-widget-button-popup-content">
                                <div className="chat-widget-button-popup-name">Fitron на связи</div>
                                <div className="chat-widget-button-popup-description">Готовы ответить на любой вопрос!</div>
                            </div>
                        </div>
                        <div className="chat-widget-button-popup-triangle"></div>
                    </div>
                    {
                        this.state.messengerActive && (
                            <div className="chat-widget-button-social chat-widget-button-show">
                                {
                                    this.state.bitrixOnlineChat && (
                                        <button
                                            className="chat-widget-button-social-item ui-icon ui-icon-service-livechat connector-icon-45"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.openBitrixChat()
                                            }}>
                                            <i></i>
                                            <span className="chat-widget-button-social-tooltip">Чат</span>
                                        </button>
                                    )
                                }
                                <a className="chat-widget-button-social-item ui-icon ui-icon-service-vk connector-icon-45"
                                   title="" href="https://vk.com/write-127849636" target="_blank">
                                    <i></i>
                                    <span className="chat-widget-button-social-tooltip">VK</span>
                                </a>
                            </div>
                        )
                    }
                    <div className="chat-widget-button-inner-container">
                        <div className="chat-widget-button-inner-mask"></div>
                        <div className="chat-widget-button-block">
                            {
                                !this.state.messengerActive && <div className="chat-widget-button-pulse chat-widget-button-pulse-animate"></div>
                            }
                            <div className="chat-widget-button-inner-block">
                                {
                                    !this.state.messengerActive ? (
                                        <div className="chat-widget-button-icon-container">
                                            <div data-b24-crm-button-icon="openline"
                                                 className="chat-widget-button-inner-item chat-widget-button-icon-animation"
                                                 onClick={(e) => {e.stopPropagation(); this.toggleLines(true); this.hidePopup(); this.closeBitrixChat()}}
                                            >
                                                <svg className="chat-crm-button-icon chat-crm-button-icon-active" width="28"
                                                     height="29"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path className="chat-crm-button-chat-icon"
                                                          d="M25.99 7.744a2 2 0 012 2v11.49a2 2 0 01-2 2h-1.044v5.162l-4.752-5.163h-7.503a2 2 0 01-2-2v-1.872h10.073a3 3 0 003-3V7.744zM19.381 0a2 2 0 012 2v12.78a2 2 0 01-2 2h-8.69l-5.94 6.453V16.78H2a2 2 0 01-2-2V2a2 2 0 012-2h17.382z"
                                                          fill=" #FFFFFF" fillRule="evenodd"></path>
                                                </svg>
                                            </div>

                                        </div>
                                    ) : (
                                        <div className="chat-widget-button-inner-item chat-widget-button-close"
                                             onClick={this.toggleLines.bind(this, false)}
                                        >
                                            <svg className="chat-widget-button-icon chat-widget-button-close-item"
                                                 xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
                                                <path fill="#FFF" fillRule="evenodd"
                                                      d="M18.866 14.45l9.58-9.582L24.03.448l-9.587 9.58L4.873.447.455 4.866l9.575 9.587-9.583 9.57 4.418 4.42 9.58-9.577 9.58 9.58 4.42-4.42"></path>
                                            </svg>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SupportChatWidget;
